import { Icon, Icons } from 'components/Icon';
import React, { useState } from 'react';
import male from '../../../../../assets/male-big.png';
import female from '../../../../../assets/female-big.png';
import { Spouses } from 'service/dto/spouse.dto';
import { UserInfoDto } from 'service/dto/user.dto';

export default function SpouseList({
  items,
  user
}: {
  items: Spouses;
  user: UserInfoDto | undefined;
}) {
  const [isExpand, setIsExpand] = useState(false);

  return (
    <div>
      <div className="mt-2 flex flex-col">
        <div className="w-full rounded-md bg-white shadow-sm">
          <div className="border-b border-[#E5E5E5]">
            <div
              tabIndex={-1}
              role="button"
              className="flex items-center justify-between p-3 px-5"
              onClick={() => setIsExpand(prevState => !prevState)}
            >
              <div className="flex items-center gap-3">
                <span className="text-base font-normal text-[#34475E]">
                  Spouse
                </span>
                <span className="h-4 w-4 rounded-full bg-[#FF6600] text-center text-[10px] text-white">
                  {items?.length}
                </span>
              </div>
              <div className={isExpand ? 'rotate-180' : ''}>
                <Icon name={Icons.ArrowDownCircle} />
              </div>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-10 px-4 pb-1">
            <div className="mr-3 space-y-2">
              <img
                src={user?.gender === 'Male' ? male : female}
                className="h-[6.5rem] w-[6.5rem] object-contain"
              />
            </div>
            <div className="my-2 mr-3 space-y-2">
              <div className="font-circular text-sm font-medium text-slate-600">
                Total Account
              </div>
              <div className="font-circular text-xl font-medium text-slate-600">
                {items && items?.length < 10
                  ? `0${items?.length}`
                  : items?.length}
              </div>
            </div>
          </div>
        </div>
      </div>

      {isExpand && (
        <div>
          {(items ?? []).map((item, idx) => (
            <div className="mt-2 flex flex-col" key={item.id}>
              <div className="w-full rounded-md bg-white shadow-sm">
                <div className="bg-[#FF660005]">
                  <div className="ml-5 flex items-center justify-between p-2 px-5">
                    <div className="flex flex-col">
                      <span className="text-base font-normal text-[#FF6606]">
                        Spouse {idx + 1}
                      </span>
                      <div className="mt-1 flex items-center gap-1 text-sm font-bold text-[#585858]">
                        {`${item.spouseFirstName} ${item.spouseMiddleName} ${item.spouseLastName}`}{' '}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-6 flex flex-wrap items-center justify-between px-4 pb-1">
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Email
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {item.emailAddress}
                    </div>
                  </div>
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Phone number
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {item.phoneNumber}
                    </div>
                  </div>
                  <div className="my-2 mr-3 space-y-2">
                    <div className="font-circular text-[13px] font-normal text-[#7A7C87]">
                      Gender
                    </div>
                    <div className="font-circular text-base font-medium text-[#585858]">
                      {item.gender}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
